module.exports = __webpack_public_path__ + "static/media/dice_6.bb98a299.svg";